<template>
  <v-flex
    column
    role="region"
    aria-label="Terms and conditions content"
  >
    <!-- Decorative Parallax Banner with accessible image role -->
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/tclayout-cover.png"
      height="350"
      role="img"
      aria-label="Terms and Conditions Banner"
    />

    <v-card
      flat
      role="region"
      aria-label="Terms and Conditions Content"
    >
      <v-layout
        :class="{
          'column pb-2': $vuetify.breakpoint.mdAndDown,
          'row pb-2': $vuetify.breakpoint.lgAndUp
        }"
        role="presentation"
      >
        <v-flex
          xs12
          sm12
          md12
          lg8
          offset-lg2
          justify-center
        >
          <v-card
            class="profile-section-card--flex-toolbar"
            flat
            role="group"
            aria-label="Terms and Conditions Sections"
          >
            <v-card flat>
              <v-container
                fluid
                grid-list-md
              >
                <!-- Accessible Tabs -->
                <v-tabs
                  fixed-tabs
                  color="accent"
                  show-arrows
                  centered
                  next-icon="fad fa-chevron-right"
                  prev-icon="fad fa-chevron-left"
                  slider-color="accent"
                  role="tablist"
                  aria-label="Terms and Conditions Navigation Tabs"
                >
                  <v-tabs-slider />
                  <v-tab
                    v-for="tab in tabs"
                    :key="tab.id"
                    :to="tab.route"
                    exact
                    role="tab"
                    :aria-selected="$route.path === tab.route"
                    :tabindex="$route.path === tab.route ? 0 : -1"
                  >
                    <v-icon
                      :aria-hidden="true"
                      class="mr-1"
                    >
                      {{ tab.icon }}
                    </v-icon>
                    <span class="sr-only">{{ $t(`tc.tabs.${tab.id}`) || tab.id }}</span>
                  </v-tab>
                </v-tabs>

                <!-- Dynamic Tab Content Area -->
                <router-view
                  role="region"
                  aria-live="polite"
                  aria-label="Terms and Conditions Content Section"
                />
              </v-container>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import tabs from "@/constants/tc.tabs.js";

export default {
  name: "TcLayout",
  data() {
    return {
        tabs: tabs.list,
    }
  },
};
</script>
